export default __webpack_public_path__ + "static/media/help_1_6.44ed6a40.gif";